import { createContext, useContext, ReactNode, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

interface ThemeConfig {
  railBg: string;
  logoColor: 'light' | 'dark';
}

const routeThemes: Record<string, ThemeConfig> = {
  '/': {
    railBg: 'bg-gradient-to-b from-slate-800 to-slate-900',
    logoColor: 'light'
  },
  '/directory': {
    railBg: 'bg-gradient-to-b from-slate-800 to-slate-900',
    logoColor: 'light'
  },
  '/live': {
    railBg: 'bg-gradient-to-b from-slate-800 to-slate-900',
    logoColor: 'light'
  },
  '/events': {
    railBg: 'bg-gradient-to-b from-slate-800 to-slate-900',
    logoColor: 'light'
  },
  '/ministries': {
    railBg: 'bg-gradient-to-b from-slate-800 to-slate-900',
    logoColor: 'light'
  },
  '/tools': {
    railBg: 'bg-gradient-to-b from-slate-800 to-slate-900',
    logoColor: 'light'
  }
};

const defaultTheme: ThemeConfig = {
  railBg: 'bg-gradient-to-b from-slate-800 to-slate-900',
  logoColor: 'light'
};

interface ThemeContextType {
  theme: ThemeConfig;
}

const ThemeContext = createContext<ThemeContextType>({ theme: defaultTheme });

export function ThemeProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  
  const theme = useMemo(() => {
    return routeThemes[location.pathname] || defaultTheme;
  }, [location.pathname]);

  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
